import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

type ConfirmationDialogProps = {
  open: boolean;
  titleId: string;
  contentId: string;
  primaryActionTitleId: string;
  primaryAction: () => void;
  secondaryActionTitleId: string;
  secondaryAction: () => void;
};

export const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const { open, primaryAction, secondaryAction } = props;
  return (
    <Dialog
      open={open}
      onClose={secondaryAction}
      PaperProps={{
        sx: {
          borderRadius: 2.5,
        },
      }}
    >
      <DialogTitle
        variant='h5'
        sx={{ textAlign: 'center', fontWeight: 600, pt: 10, pb: 5 }}
      >
        <FormattedMessage id={props.titleId} />
      </DialogTitle>
      <DialogContent sx={{ px: 8, textAlign: 'center' }}>
        <FormattedMessage id={props.contentId} />
      </DialogContent>
      <DialogActions sx={{ py: 8, justifyContent: 'center', mx: 20, my: 10 }}>
        <Button
          variant='outlined'
          size='large'
          sx={{
            borderRadius: 8,
            px: 11,
            py: 4,
            mr: 10,
            borderColor: '#626a7a',
            color: '#626a7a',
          }}
          onClick={secondaryAction}
        >
          <FormattedMessage id={props.secondaryActionTitleId} />
        </Button>
        <Button
          variant='contained'
          disableElevation
          onClick={primaryAction}
          autoFocus
          size='large'
          color='secondary'
          sx={{
            borderRadius: 8,
            px: 11,
            py: 4,
          }}
        >
          <FormattedMessage id={props.primaryActionTitleId} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
